import EditTable from './Main';
export default EditTable;
